export default "__VITE_ASSET__DV1W0xSD__"